export default __webpack_public_path__ + "static/media/control-camera-icon.bb6a5f47.svg";